import type { ErrorSummary } from '../types';

interface Props {
  errors: ErrorSummary[];
}

export function ErrorsCard({ errors }: Props) {
  const totalErrors = errors.reduce((sum, e) => sum + e.errorCount, 0);

  return (
    <div className="hud-card">
      <div className="hud-corner-tl" /><div className="hud-corner-tr" /><div className="hud-corner-bl" /><div className="hud-corner-br" />
      <div className="hud-card-header">
        <div className="flex items-center gap-2.5">
          <svg className="w-4 h-4 text-hud-red opacity-80" viewBox="0 0 16 16" fill="none">
            <path d="M8 2L14 13H2L8 2Z" stroke="currentColor" strokeWidth="1.2"/>
            <line x1="8" y1="6" x2="8" y2="9" stroke="currentColor" strokeWidth="1.2"/>
            <circle cx="8" cy="11" r="0.7" fill="currentColor"/>
          </svg>
          <span className="hud-card-title" style={{ color: '#ff3355', textShadow: '0 0 8px rgba(255,51,85,0.2)' }}>Errors</span>
        </div>
        <span className="hud-card-badge" style={{ background: 'rgba(255,51,85,0.2)', color: '#ff3355', borderColor: 'rgba(255,51,85,0.4)' }}>
          {totalErrors > 0 ? `${totalErrors} TOTAL` : '24H'}
        </span>
      </div>
      <div className="hud-card-body">
        <div className="space-y-0">
          {errors.map((error, idx) => (
            <div
              key={`${error.device}-${error.eventName}-${idx}`}
              className="flex items-center justify-between py-2.5 border-b border-card-inner last:border-b-0"
            >
              <div className="flex flex-col gap-0.5">
                <span className="font-mono text-xs text-hud-red">{error.eventName}</span>
                <span className="font-mono text-[10px] text-[#4a6a7a]">{error.device}</span>
              </div>
              <span className="font-display text-xl font-bold text-hud-red min-w-[40px] text-right" style={{ textShadow: '0 0 12px rgba(255,51,85,0.2)' }}>
                {error.errorCount}
              </span>
            </div>
          ))}

          {errors.length === 0 && (
            <div className="text-center py-8">
              <p className="font-mono text-sm text-hud-green" style={{ textShadow: '0 0 8px rgba(0,255,136,0.2)' }}>No errors in last 24 hours</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
